import { render, staticRenderFns } from "./OriginFromApp.vue?vue&type=template&id=562aab00&"
import script from "./OriginFromApp.vue?vue&type=script&lang=js&"
export * from "./OriginFromApp.vue?vue&type=script&lang=js&"
import style0 from "./OriginFromApp.vue?vue&type=style&index=0&id=562aab00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports